export default "<template>\r\n  <v-row justify=\"center\" align=\"center\">\r\n    <v-chip draggable>Default</v-chip>\r\n  </v-row>\r\n</template>\r\n";